function AnchorScroll(){

	this.FLAG = false;
	this.SPEED = 500;
	
	this.$jsScroll = $('.js-scroll');

	this.browser = $((navigator.userAgent.indexOf('Safari')!=-1)? 'body' : 'html');

	//アンカー登録

	var self = this;

	// $('a[href^=#],area[href^=#]').on('click.scroll', function(event){
	// 	event.preventDefault();
	// 	var thisHref = $(this).attr('href');
	// 	self.action(self,thisHref);
	// 	// return false;
	// });
	// articlelist

	this.$jsScroll.on('click.scroll', function(event){
		event.preventDefault();
		var thisHref = $(this).attr('href');
		self.action(self,thisHref);
	});

}

AnchorScroll.prototype = {
	action : function(G,href){
		if(!G.FLAG){
			var target = $(href == '#' || href == '' ? 'html' : href);
			if (target.offset()){
				G.FLAG = true;
				var position = target.offset().top;
				if (href == '#'){
					position = 0;
				};
				G.browser.animate({scrollTop:position}, G.SPEED, '', function(){
					G.FLAG = false;
				});
			}
		}
	}
};

//インスタンスを生成し即時実行
module.exports = new AnchorScroll();


/*****************
 ** WEBPACK FOOTER
 ** ./app/source/pc/js/module/anchor_scroll.js
 ** module id = 4
 ** module chunks = 5
 **/